/* 
    This script is used on:
    https://info.shipstation.com/bigcommerce
*/

import { partnersAppIntegrationModule, onSignupFormReady } from '../partners';

const registerEndpoint = partnersAppIntegrationModule.partnerLpAppSettings.registerEndpoint;
const optinConsentCountries = partnersAppIntegrationModule.partnerLpAppSettings.optinConsentCountries;

// Bind to the LIVE form after Vue rebuilds it, not on the racy $(document).ready. See onSignupFormReady in ../partners.js.
onSignupFormReady(function() {
    partnersAppIntegrationModule.ss_handleHowDidYouHearAboutUs();

    $('#affiliate').val('BigCommerce');
    $('#hubspot_cookie').val(document.cookie.match(/(?:^|; )hubspotutk=([^;]*)/)?.[1] || '');

    var data = {
        code: partnersAppIntegrationModule.getParameterByName('code'),
        scope: partnersAppIntegrationModule.getParameterByName('scope'),
        context: partnersAppIntegrationModule.getParameterByName('context')
    };
    
    // Check if input #experiments exist
    partnersAppIntegrationModule.checkIfExperimentsExist();

    // Add journey_id hidden field to the form if it doesn't exist, then capture YOFI journey_id
    if (!$('#journey_id').length) {
        $('#registration-form').append('<input type="hidden" id="journey_id" name="journey_id" value="" />');
    }
    partnersAppIntegrationModule.captureJourneyId('#journey_id');

    $('#register-button').attr('disabled', 'disabled').css('background-color', '#ddd').val('One Moment...');

    $.ajax({
        type: 'POST',
        url: 'https://ss.shipstation.com/api/marketplace/bigcommerce/settoken',
        data: data,
        success: function(resp) {
            $('#register-button').removeAttr('disabled').css('background-color', '').val("ACTIVATE FREE ACCOUNT!");
        
            $('#email').val(resp.data.email);
            $('#phone').val(resp.data.phone);
            $('#firstName').val(resp.data.firstName);
            $('#lastName').val(resp.data.lastName);
            $('#companyName').val(resp.data.companyName);
        
            document.cookie = `bc-t=${resp.data.token}; domain=.shipstation.com; max-age=86400; path=/; samesite=none; secure`;
        
            const countryNameToCode = {
                "United States": "US",
                "Australia": "AU",
                "New Zealand": "NZ",
                "Canada": "CA",
                "France": "FR",
                "Germany": "DE",
                "Mexico": "MX",
                "United Kingdom": "GB"
            };
            let countryCode = countryNameToCode[resp.data.country] || resp.data.country_code;

            switch(countryCode) {
                case "US":
                    $('#countryCode').val("United States");
                    break;
                case "AU":
                    $('#countryCode').val("Australia");
                    $('a#sstos').attr('href', 'https://www.shipstation.com/terms-of-service-australia');
                    $('a#sspp').attr('href', 'https://www.shipstation.com/privacy-policy-australia');
                    break;
                case "NZ":
                    $('#countryCode').val("New Zealand");
                    $('a#sstos').attr('href', 'https://www.shipstation.com/terms-of-service-australia');
                    $('a#sspp').attr('href', 'https://www.shipstation.com/privacy-policy-australia');
                    break;
                case "CA":
                    $('#countryCode').val("Canada");
                    $('a#sstos').attr('href', 'https://www.shipstation.com/ca/terms-of-service');
                    $('a#sspp').attr('href', 'https://www.shipstation.com/ca/privacy-policy');
                    break;
                case "FR":
                    $('#countryCode').val("France");
                    $('a#sstos').attr('href', 'https://www.shipstation.com/terms-of-service-france/');
                    $('a#sspp').attr('href', 'https://www.shipstation.com/privacy-policy-france/');
                    $('.optin-consent-field').show();
                    break;
                case "DE":
                    $('#countryCode').val("Germany");
                    // TODO: Add Germany TOS and Privacy Links
                    $('.optin-consent-field').show();
                    break;
                case "MX":
                    $('#countryCode').val("Mexico");
                    // TODO: Add Mexico TOS and Privacy Links
                    break;
                case "GB":
                    $('#countryCode').val("United Kingdom");
                    $('a#sstos').attr('href', 'https://www.shipstation.com/terms-service-united-kingdom');
                    $('a#sspp').attr('href', 'https://www.shipstation.com/privacy-policy-united-kingdom');
                    $('.vat_field').show();
                    $('input[name="optin_consent"]').addClass('required');
                    $('.optin-consent-field').show();
                    break;
                default:
                    window.alert("Unfortunately, ShipStation only supports shippers in the United States, Canada, Mexico, Australia, New Zealand, Germany, France, and United Kingdom at this time.");
                    $('#register-button').attr('disabled', 'disabled').css('background-color', '#ddd');
                    break;
            }
        
            partnersAppIntegrationModule.updateEuShipmentVolumeSelectOptions($('#countryCode').val(), '#shipment_volume');
        },
        
        error: function(resp, a, b, c) {
            $('#register-button').removeAttr('disabled').css('background-color', '').val("ACTIVATE FREE ACCOUNT!");
        }
    });

    $('#loginButton').click(function(e) {
        e.preventDefault();
        const bcToken = document.cookie.match(/(?:^|; )bc-t=([^;]*)/)?.[1] || '';
        document.cookie = `bigcommerce-token=${partnersAppIntegrationModule.getParameterByName('context')}.${bcToken}; domain=.shipstation.com; max-age=86400; path=/; samesite=none; secure`;
        document.cookie = 'bc-t=; domain=.shipstation.com; max-age=0; path=/; samesite=none; secure';

        window.location = 'https://ss.shipstation.com';
    });

    $('#registration-form').append('<input type="hidden" id="registration_channel" name="registration_channel" value="bigcommerce" />');

    if (typeof emailBlacklistEnabled !== 'undefined' && emailBlacklistEnabled && typeof emailBlacklistDomains !== 'undefined') {
    	$.validator.addMethod("emailBlacklist", function(value, element) {
    		if (!value) return true;
    		var domain = value.split('@')[1];
    		if (!domain) return true;
    		domain = domain.toLowerCase();
    		return !emailBlacklistDomains.some(function(pattern) {
    			pattern = pattern.toLowerCase();
    			if (pattern.endsWith('.*')) {
    				var base = pattern.slice(0, -2);
    				return domain.startsWith(base + '.');
    			}
    			return domain === pattern;
    		});
    	}, typeof emailBlacklistMessage !== 'undefined' ? emailBlacklistMessage : "Please enter a valid business email address");
    }

    $('#registration-form').validate({
        rules: {
            'password': {
                minlength: 7
            },
            'password-confirm': {
                equalTo: '#password'
            },
            'answers[0]': {
                required: true
            }
        },
        messages: {
            'password-confirm': {
                equalTo: 'Passwords do not match',
                required: 'Please confirm your password'
            },
            'password': {
                required: 'A password is required',
                minlength: 'Passwords must be at least 7 characters'
            },
            'answers[0]': {
                required: 'Please answer How did you hear about us?'
            }
        },
        submitHandler: function(form) {
            $('#register-button').attr('disabled', 'disabled').css('background-color', '#ddd').val('One Moment...');
            partnersAppIntegrationModule.updateTargetAppAtSubmission();

 

            $.ajax({
                type: 'POST',
                url: registerEndpoint,
                data: $(form).serialize(),
                success: function(resp) {
                    if (resp.success) {
                        if (resp.userId && resp.username) {
                            document.cookie = `auth=${resp.authToken}; domain=.shipstation.com; path=/; samesite=none; secure`;

                            // Set email cookie
                            const { host } = window.location;
                            const domain = host.includes("shipstation") ? `.shipstation${host.split("shipstation").pop()}` : host;
                            document.cookie = `signup_email=${resp.username}; path=/; domain=${domain}; samesite=none; secure;`;

                            const browserLanguage = navigator.language.toLowerCase() || 'en-us';

                            const currentUnixTimestamp = Date.now();
                             // Modulo used to convert to midnight date format for hubspot
                            const trialActivationDate = currentUnixTimestamp - (currentUnixTimestamp % 86400000) + 86400000;
                            const trialEndDate = resp.trialEndDate ? resp.trialEndDate - (resp.trialEndDate % 86400000) : '';

                            dataLayer.push({
                                event: 'account_created', // hardcoded
                                userId: resp.userId,
                                email: resp.username,
                                orderId: resp.refno,
                                home_country: $('#countryCode').val(),
                                affiliate: $('#affiliate').val(),
                                referrer: $('#referrer').val() || '',
                                referral_code: $('#referral_code').val(),
                                coupon: $('#coupon').length ? $('#coupon').val() : '',
                                phonenumber: $('input[name=phone]').val() || '',
                                company: $('#reg-compname').val(),
                                howdidyouhearaboutus: $('#howdidyouhearaboutus').length ? $('#howdidyouhearaboutus').val() : '',
                                shipment_volume: $('#shipment_volume').length ? $('#shipment_volume').val() : ''
                            });

                            // Segment identify and track for Account Created
                            partnersAppIntegrationModule.trackSegmentAccountCreated(resp, $('#countryCode').val());

                            // send to hubspot
                            $.get('https://www.shipstation.com/hubspot/form-api.php', {
                                pageName: document.title,
                                pageURL: window.location.href,
                                firstname: $("#firstName").val() || "",
                                lastname: $("#lastName").val() || "",
                                company: $("#companyName").val() || "",
                                phonenumber: $('#phone').val() || "",
                                refno: resp.refno,
                                email: resp.username,
                                userId: resp.userId,
                                howdidyouhearaboutus: $('#howdidyouhearaboutus').length ? $('#howdidyouhearaboutus').val() : '',
                                vat_number: $('input[name=vat_number]').length ? $('input[name=vat_number]').val() : '',
                                optin_consent: optinConsentCountries.includes($('#countryCode').val()) ? $("input[name=optin_consent]:checked").val() ? "yes" : "no" : "",
                                home_country: $('#countryCode').length ? $('#countryCode').val() : '',
                                referral_code: $('#referral_code').length ? $('#referral_code').val() : '',
                                coupon: $('#coupon').length ? $('#coupon').val() : '',
                                verified: resp.verified || '',
                                trialActivationDate: trialActivationDate,
                                trialEndDate: trialEndDate,
                                browserLanguage: browserLanguage,
                                utcOffsetInMinutes: new Date().getTimezoneOffset() * -1,
                                isDST: window.luxon ? window.luxon.DateTime.local().isInDST : null,
                                shipment_volume: $('#shipment_volume').length ? $('#shipment_volume').val() : '',
                                device_type: $('#device_type').val() || '',
                                targetApp: $('#targetApp').length ? $('#targetApp').val() : 'default',
                            });
                        }
                        const bcTokenVal = document.cookie.match(/(?:^|; )bc-t=([^;]*)/)?.[1] || '';
                        document.cookie = `bigcommerce-token=${partnersAppIntegrationModule.getParameterByName('context')}.${bcTokenVal}; domain=.shipstation.com; max-age=86400; path=/; samesite=none; secure`;
                        document.cookie = 'bc-t=; domain=.shipstation.com; max-age=0; path=/; samesite=none; secure';
                        setTimeout(function() {
                            window.location = partnersAppIntegrationModule.getRegisterServer();
                        }, 1000);
                    } else {
                        window.alert(resp.message);
                    }
                    $('#register-button').removeAttr('disabled').css('background-color', '').val("ACTIVATE FREE ACCOUNT!");
                },
                error: function(resp, a, b, c) {
                    $('#register-button').removeAttr('disabled').css('background-color', '').val("ACTIVATE FREE ACCOUNT!");
                }
            });
        }
    });

    if (typeof emailBlacklistEnabled !== 'undefined' && emailBlacklistEnabled) {
    	$("#email").rules("add", { emailBlacklist: true });
    }
});
